module.exports = require("ember-power-select/components/power-select-multiple");